"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDownIcon = void 0;
const react_1 = __importDefault(require("react"));
const icon_1 = __importDefault(require("./icon"));
exports.ChevronDownIcon = react_1.default.forwardRef(function ChevronDownIcon(props, ref) {
    return (react_1.default.createElement(icon_1.default, { ref: ref, ...props },
        react_1.default.createElement("path", { d: "M6 9l6 6 6-6" })));
});
exports.default = exports.ChevronDownIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hldnJvbi1kb3duLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaWNvbnMvY2hldnJvbi1kb3duLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFFMUIsa0RBQXlDO0FBRTVCLFFBQUEsZUFBZSxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQTJCLFNBQVMsZUFBZSxDQUFDLEtBQUssRUFBRSxHQUFHO0lBQzNHLE9BQU8sQ0FDTCw4QkFBQyxjQUFJLElBQUMsR0FBRyxFQUFFLEdBQUcsS0FBTSxLQUFLO1FBQ3ZCLHdDQUFNLENBQUMsRUFBQyxjQUFjLEdBQUcsQ0FDcEIsQ0FDUixDQUFDO0FBQ0osQ0FBQyxDQUFDLENBQUM7QUFFSCxrQkFBZSx1QkFBZSxDQUFDIn0=